import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@auth0/auth0-angular';
import { DataService } from 'src/app/services/data.service';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2'
import { PersonaService } from 'src/app/services/persona.service';
@Component({
  selector: 'app-perfil-usuario',
  templateUrl: './perfil-usuario.component.html',
  styleUrls: ['./perfil-usuario.component.css']
})
export class PerfilUsuarioComponent implements OnInit {

  perfilForm: FormGroup | any;
  userId: any;
  constructor(private fb: FormBuilder, private dataService: DataService, private auth: AuthService, private commonService: CommonService, private personaService: PersonaService) {
    this.perfilForm = this.fb.group({
      guid: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      rut: ['', [Validators.required, this.commonService.createRutValidator(), Validators.pattern(/^[1-9]\d*[-|‐]{1}[0-9kK]{1}$/)]],
      nombre: ['', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]],
      apellidoPaterno: ['', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]],
      apellidoMaterno: ['', [Validators.required, Validators.pattern('^[A-Za-zÁáÉéÍíÓóÚúÜüÑñ ]+$')]]
    });
  }

  ngOnInit(): void {
    this.perfilForm.get('email').disable();
    this.auth.user$.subscribe(user => {
      if (user && user['user_metadata']) {
        this.userId = user['user_metadata'].guid_credipal;
        this.getPefilUsuario();     
      }
    });

  }

  submitForm(): void {
    if (this.perfilForm.valid) {
      const endpoint = `persona/${this.userId}/perfil`;
      this.dataService.postData(this.perfilForm.getRawValue() , endpoint).subscribe({
        next: (v) => {   
          this.personaService.setPersona();
          Swal.fire({
            icon: 'success',
            title: 'Exito!!',
            text: 'Se ha actualizado el perfil del usuario',
            showConfirmButton: true,
          })
        },
        error: (e) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se ha podido actualizar el perfil del usuario',
            showConfirmButton: true,
          })
        }
      });
    } else {
      this.perfilForm.markAsTouched();
    }
  }

  getPefilUsuario(): void {
    if (this.userId) {
      const endpoint = `persona/${this.userId}/perfil`;
      this.dataService.getData(endpoint).subscribe({
        next: (v) => { 
          this.commonService.setFormGroupValues(this.perfilForm, v);
          if(this.perfilForm.get('rut').value != ''){
            this.perfilForm.get('rut').disable();
          }
        },
        error: (e) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se ha podido obtener el perfil del usuario',
            showConfirmButton: true,
          })
        }
    });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se ha podido obtener el perfil del usuario',
        showConfirmButton: true,
      })
    }
  }

}
